import type { CurrentUserDto } from '../types/UserDtos';
import { getCurrentUser } from './react/services/CurrentUser';
import { hasBasicHr } from './react/services/User';
import * as R from './routes';

const routePairsForHr = {
    [R.YOUR_SURVEYS_SHARED]: R.YOUR_SURVEYS_COMPANY,
    [R.YOUR_SURVEYS_SHARED_WITH_SURVEY]: R.YOUR_SURVEYS_COMPANY_WITH_SURVEY,
    [R.YOUR_SURVEYS_SHARED_WITH_SURVEY_PRINT]: R.YOUR_SURVEYS_COMPANY_WITH_SURVEY_PRINT,
};

const getRoutePairsForUser = (user: CurrentUserDto): Partial<typeof routePairsForHr> => {
    if (hasBasicHr(user)) {
        return routePairsForHr;
    } else {
        return {};
    }
};

export const getAdminRouteForNavigation = (oldRoute: keyof typeof routePairsForHr) => {
    return getAdminRouteForNavigationForUser(getCurrentUser(), oldRoute);
};

export const getAdminRouteForNavigationForUser = (user: CurrentUserDto, oldRoute: keyof typeof routePairsForHr) => {
    const newRoute = getRoutePairsForUser(user)[oldRoute];

    return newRoute ?? oldRoute;
};

export const getRedirectsForHR = () => {
    const user = getCurrentUser();

    return Object.entries(getRoutePairsForUser(user)).filter(([oldPath, newPath]) => oldPath !== newPath);
};
